import $ from 'jquery';
import './_foundationModules.js';

$(document).foundation();
